import Alerts from '@rover/utilities/Alerts';

import $ from '@rover/globals/jquery';
import _ from '@rover/globals/underscore';
import Backbone from '@rover/globals/backbone';
import Mustache from '@rover/globals/Mustache';

export default Backbone.View.extend({
  template: Mustache.template('new_design/account_conversations/creditcard'),
  events: {
    'click .js-remove-cc': 'confirmDelete',
  },
  paymentMethodMap: {
    Visa: ['visa', 'Visa'],
    MasterCard: ['mastercard', 'MasterCard'],
    Discover: ['discover', 'Discover'],
    'American Express': ['amex', 'AmEx'],
  },
  initialize(options) {
    _.bindAll(this, 'render', 'confirmDelete', 'deleteCard');
    this.collectionView = options.collectionView;
  },
  confirmDelete() {
    if (confirm('Are you sure you want to remove this card?')) {
      this.deleteCard();
    }
  },
  deleteCard() {
    const ccLength = this.collectionView.collection.models.length;

    $('.js-payment-alerts-container').empty();

    if (ccLength >= 2) {
      this.$el.addClass('faded');
      this.$('.js-remove-cc').prop('disabled', true);
      const creditCardView = this;
      this.model.destroy({
        wait: true,
        success() {
          creditCardView.remove();
          creditCardView.collectionView.trigger('cardRemoved');
          Alerts.showToast({
            severity: 'success',
            message: 'Your card has been removed.',
          });
        },
        error(model, xhr) {
          creditCardView.$el.removeClass('faded');
          creditCardView.$('.js-remove-cc').prop('disabled', false);
          if (xhr.status === 500) {
            Alerts.showToast({
              severity: 'danger',
              message:
                'We were unable to remove this credit card. Please contact Rover support for assistance.',
            });
          } else if (xhr.status === 422) {
            Alerts.showToast({
              severity: 'danger',
              message:
                'You must have at least one active card on your account. To delete this card, add another first.',
            });
          }
        },
      });
    } else {
      Alerts.showToast({
        severity: 'danger',
        message:
          'You must have at least one active card on your account. To delete this card, add another first.',
      });
    }
  },
  render(data) {
    const renderData = data;
    const cardType = this.model.get('card_type');

    if (Object.prototype.hasOwnProperty.call(this.paymentMethodMap, cardType)) {
      renderData.cardIcon = this.paymentMethodMap[cardType][0];
      renderData.cardDisplay = this.paymentMethodMap[cardType][1];
      this.$el.html(this.template.render(renderData));
    }
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/checkout/credit_card_view.js